import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import {
    SERVICE_TEMPLATE_SCHEDULE_FILTERABLE_STATUSES,
    serviceTemplateScheduleDisplayStatusLabel,
    ServiceTemplateScheduleFilterableStatus,
} from "./serviceTemplateScheduleDisplayStatus";

const STATUS_ITEMS: Array<
    PickerItemData<ServiceTemplateScheduleFilterableStatus>
> = SERVICE_TEMPLATE_SCHEDULE_FILTERABLE_STATUSES.map((status) => ({
    value: status,
    label: serviceTemplateScheduleDisplayStatusLabel[status],
}));

const renderStatusSummary = (
    statuses: readonly ServiceTemplateScheduleFilterableStatus[],
) =>
    statuses.length === 1
        ? serviceTemplateScheduleDisplayStatusLabel[statuses[0]]
        : `${statuses.length} statuses`;

interface Props {
    selectedStatuses: ServiceTemplateScheduleFilterableStatus[];
    onChange: (statuses: ServiceTemplateScheduleFilterableStatus[]) => void;
}

// Status filter for the schedules table page header (PRO-10571). Only 3
// static options (Select is reserved for ≤5 static options with no search —
// mirrors ServiceTemplateScheduleOccurrenceStatusFilter), and defaults to
// nothing selected — i.e. no filtering, every status shown.
export const ServiceTemplateScheduleStatusFilter = ({
    selectedStatuses,
    onChange,
}: Props) => (
    <Picker.Select
        multiple
        items={STATUS_ITEMS}
        value={selectedStatuses}
        onValueChange={onChange}
        placeholder="All statuses"
        renderValue={renderStatusSummary}
    />
);
